/* eslint-disable @typescript-eslint/no-unused-vars */

export default class OpenURLBase {
  constructor() {
    //
  }

  public async open(_url:string): Promise<boolean> {
    return Promise.reject(new Error("openurl.base.open must be overridden in the subclass"));
  }
}